module.exports = __webpack_public_path__ + "img/menu-thai-express.0cf377e9.jpg";